import { ActionBar, Button, Portal } from '@chakra-ui/react'

type SettingsActionBarProps = {
  /** Show/hide the bar (usually: dirty && !loading) */
  visible: boolean

  /** Cancel button */
  onCancel: () => void
  cancelLabel?: string
  cancelDisabled?: boolean

  /** Save button */
  onSave: () => void | Promise<void>
  saveLabel?: string
  saveDisabled?: boolean
  saving?: boolean
}

export function SettingsActionBar({
  visible,
  onCancel,
  cancelLabel = 'Abbrechen',
  cancelDisabled = false,

  onSave,
  saveLabel = 'Änderungen speichern',
  saveDisabled = false,
  saving = false,
}: SettingsActionBarProps) {
  if (!visible) return null

  return (
    <ActionBar.Root open>
      <Portal>
        <ActionBar.Positioner>
          <ActionBar.Content>
            <Button variant="ghost" onClick={onCancel} disabled={cancelDisabled}>
              {cancelLabel}
            </Button>

            <Button
              variant="subtle"
              colorPalette="green"
              onClick={onSave}
              loading={saving}
              disabled={saveDisabled || saving}
            >
              {saveLabel}
            </Button>
          </ActionBar.Content>
        </ActionBar.Positioner>
      </Portal>
    </ActionBar.Root>
  )
}
